import 'regenerator-runtime/runtime'
import '@/styles/main.scss'
import Vue from 'vue'
import App from './App.vue'
import { router } from '@/router'
import { store } from '@/store/store'
import i18n from '@/lang/i18n'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import iconLibrary from './iconLibrary'
import apiExceptionType from '@/utils/apiExceptionType'
import globalMixin from '@/globalMixin'
import { AppMixins } from '@/mixins/app-mixins.mixin'
import Router from 'vue-router'
import { RouterUtils } from '@/shared/util/router-utils'
import { Promised } from 'vue-promised'

// Import all plugins
require('@/plugins')
require('@/directives')
require('@/filters')
require('@/shared/components')
require('@/shared/resources')

iconLibrary.init()
Vue.component('FaIcon', FontAwesomeIcon)
Vue.component('FaLayers', FontAwesomeLayers)
Vue.component('Promised', Promised)

Vue.mixin(globalMixin)
Vue.mixin(AppMixins)

Vue.prototype.$eventHub = new Vue()
Vue.prototype.$apiExceptions = apiExceptionType
Vue.config.productionTip = false

Router.prototype.push = RouterUtils.push

new Vue({
    i18n,
    store,
    router,
    render: h => h(App)
}).$mount('#app')
